module.exports = __webpack_public_path__ + "static/Debts-NZ-F2-c96a1078c9c607298617488e0fe6611a.webp";